import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { Helmet } from "react-helmet";
import image1 from "../images/plan/r1.jpeg";
import image2 from "../images/plan/r2.jpeg";
import image3 from "../images/plan/r3.jpeg";
import image4 from "../images/plan/r4.jpeg";
import image5 from "../images/plan/r5.jpeg";
import image6 from "../images/plan/r6.jpeg";

function TestimonialsPage() {
  const images = [
    { src: image1 },
    { src: image2 },
    { src: image3 },
    { src: image4 },
    { src: image5 },
    { src: image6 },
  ];

  return (
    <>
      <Helmet>
        <title>Testimonials - Price Is Right ATV</title>
        <meta
          name="description"
          content="Read testimonials for Price Is Right ATV in Turks & Caicos Islands. Discover how our ATV rentals, jet ski bookings, and drone photo shoots create thrilling and unforgettable island adventures!"
        />
      </Helmet>

      <section className="testimonial-page">
        <HeroPages name="Testimonials" />

        {/* Responsive Image Grid */}
        <div className="container mt-4" >
          <div className="row" style={{marginTop:'20px'}}>
            {images.map((image, index) => (
              <div className="col-12 col-md-3 mb-3" key={index}>
                <img
                  src={image.src}
                  alt={`Testimonial Image ${index + 1}`}
                  className="img-fluid w-100"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Call-to-Action Banner */}
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content text-center">
              <h2>Book an ATV by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone"></i>
                <h3 style={{ color: "gold" }}>+16 493413819</h3>
              </span>
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default TestimonialsPage;

